import { render, staticRenderFns } from "./ModalPreferencesAccount.vue?vue&type=template&id=d021bc54"
import script from "./ModalPreferencesAccount.vue?vue&type=script&lang=js"
export * from "./ModalPreferencesAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports